import { FromSchema } from '@40seas/entities/common';
import { z } from 'zod';

export const ProviderFeeSchema = z
    .object({
        name: z.string(),
        planName: z.string().optional(),
        category: z.string().optional(),
        amount: z.number(),
        currency: z.string().optional(),
    })
    .strict();

export class ProviderFee extends FromSchema(ProviderFeeSchema) {
    name: string;
    planName?: string;
    category?: string;
    amount: number;
    currency?: string;
}
